import React from "react";
import { ButtonProps } from 'react-bootstrap';
import {
    PlusCircleFill, PencilFill, TrashFill, CheckCircleFill, XCircleFill,
    Search, Wrench, ArrowRepeat, ArrowLeftShort, ArrowRightShort, Download, Upload
} from 'react-bootstrap-icons';

export enum IconButtonType {
    Add,
    Edit,
    Delete,
    Save,
    Cancel,
    View,
    Fix,
    Sync,
    Next,
    Back,
    Download,
    Upload,
    None
}

export enum IconButtonPosition {
    Before,
    After
}

export const IconButtonTypeClass: Record<IconButtonType, string> = {
    [IconButtonType.Add]: 'add',
    [IconButtonType.Edit]: 'edit',
    [IconButtonType.Delete]: 'delete',
    [IconButtonType.Save]: 'save',
    [IconButtonType.Cancel]: 'cancel',
    [IconButtonType.View]: 'view',
    [IconButtonType.Fix]: 'fix',
    [IconButtonType.Sync]: 'sync',
    [IconButtonType.Next]: 'next',
    [IconButtonType.Back]: 'back',
    [IconButtonType.Download]: 'download',
    [IconButtonType.Upload]: 'upload',
    [IconButtonType.None]: 'none'
};

export const IconButtonTypeComponent : Record <IconButtonType, JSX.Element> = {
    [IconButtonType.Add]: <PlusCircleFill size={16} />,
    [IconButtonType.Edit]: <PencilFill size={14} />,
    [IconButtonType.Delete]: <TrashFill size={16} />,
    [IconButtonType.Save]: <CheckCircleFill size={16} />,
    [IconButtonType.Cancel]: <XCircleFill size={16} />,
    [IconButtonType.View]: <Search size={16} />,
    [IconButtonType.Fix]: <Wrench size={16} />,
    [IconButtonType.Sync]: <ArrowRepeat size={20} />,
    [IconButtonType.Next]: <ArrowRightShort size={24} />,
    [IconButtonType.Back]: <ArrowLeftShort size={24} />,
    [IconButtonType.Download]: <Download size={16} />,
    [IconButtonType.Upload]: <Upload size={16} />,
    [IconButtonType.None]: <></>

}

export interface IIconButton extends ButtonProps, React.HTMLAttributes<HTMLElement> {
    iconType: IconButtonType;
    spin?: boolean;
}
